import moment from 'moment';
import { humanize } from '@utils';
import { UNITS } from '@components/session-timeline/utils/constants';
import formatBPS from '../../../utils/formatBPS';

export const getLinerData = (data: any[], event: string) => {
  return data.reduce((result, { startTimeMs, endTimeMs, startValue, endValue }, index) => {
    const startMoment = moment(startTimeMs);
    const endMoment = moment(endTimeMs);
    let startUnit = UNITS[event] || '';
    let endUnit = UNITS[event] || '';
    if (startUnit === 'bps') {
      [startValue, startUnit] = formatBPS(startValue, event);
      [endValue, endUnit] = formatBPS(endValue, event)
    } else {
      startValue = humanize(startValue, '');
      endValue = humanize(endValue, '');
    }
    if (startMoment.isSame(endMoment, 'm')) {
      result.push({
        time: startTimeMs,
        value: `${startValue} ${startUnit}`
      });
    } else if (startValue === endValue) {
      result.push({
        time: [startTimeMs, endTimeMs],
        value: `${endValue} ${endUnit}`
      });
    } else {
      result.push({
        time: startTimeMs,
        value: `${startValue} ${startUnit}`
      });
      result.push({
        time: endTimeMs,
        value: `${endValue} ${endUnit}`
      });
    }
    return result;
  }, []);
};
